import Link from "next/link";
import { useTranslation } from "react-i18next";

import { interpolate, Route } from "@sol/routing";
import { ArrowRight } from "@sol/uikit/core/icons/Arrows/ArrowRight";
import { Button } from "@sol/uikit/general/Button/Button";

import { HomeCard, HomeCardDescription } from "./components/HomeCard";

export function AdminHome() {
    const [t] = useTranslation();

    return (
        <div className="grid grid-cols-1 gap-ant lg:grid-cols-2">
            <HomeCard
                title={t("component.home.manager.admin.title")}
                className="col-span-2 lg:col-span-1 lg:row-span-1"
                action={
                    <Link href={interpolate(Route.ADMIN, {})} passHref>
                        <Button
                            size="small"
                            iconPosition="end"
                            icon={<ArrowRight variant="antd" />}
                            title={t("component.home.manager.admin.cta.title")}
                            aria-label={t("component.home.manager.admin.cta.title")}
                        >
                            {t("component.home.manager.admin.cta.label")}
                        </Button>
                    </Link>
                }
            >
                <HomeCardDescription label={t("component.home.manager.admin.label")}>
                    {t("component.home.manager.admin.description")}
                </HomeCardDescription>
            </HomeCard>
        </div>
    );
}
